import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

import { IFlowNode } from '../models';
import { setEdges } from '../store';

export function useCreateChatFlowConnections(resetChanges: () => void) {
  const dispatch = useAppDispatch();
  const edges = useAppSelector(state => state.aiAgentReducer.edges);
  const nodes = useAppSelector(state => state.aiAgentReducer.nodes);

  const body = edges;

  const location = useLocation();
  const navigate = useNavigate();

  const replaceSegment = (id: string) => {
    const segments = location.pathname.split('/');

    segments[2] = id;
    const newPath = segments.join('/');

    navigate(newPath);
  };

  return useMutation({
    mutationFn: async (chatFlowId: number) => {
      const res = await $api.post(`/v1/chat-flow/block/connection/${chatFlowId}`, body);

      return res.data;
    },
    onSuccess: (data, chatFlowId) => {
      const edges = data?.data as {
        source: number;
        target: number;
        option: number | null;
        id: number;
      }[];

      const newEdges = edges.map(item => {
        const source = (nodes as IFlowNode[]).find(
          n => String(n.oldId?.includes('new') ? n?.id : n?.oldId) === String(item.source)
        );
        const target = (nodes as IFlowNode[]).find(
          n => String(n.oldId?.includes('new') ? n?.id : n?.oldId) === String(item.target)
        );

        const result: any = {
          source: String(source?.id),
          target: String(target?.id),
          id: item.id
        };

        if (source?.type === 'QUESTION_CLASSIFIER' && item.option !== null) {
          const options = source.options || (source.data as any)?.options;

          if (Array.isArray(options)) {
            const optionIndex = options.findIndex((opt: any) => opt.id === item.option);

            if (optionIndex !== -1) {
              result.sourceHandle = `source_${optionIndex}`;
              result.option = item.option || options[optionIndex]?.id;
            }
          }
        }

        return result;
      });

      dispatch(setEdges(() => newEdges));
      replaceSegment(String(chatFlowId));
      resetChanges();
    }
  });
}
